import axiosInstance from "../utils/axios"

export const smkMajorService = {
  fetchAllWithoutPaginate: async () => {
    const response = await axiosInstance.get('/smk-major/all')
    return response.data
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/smk-major',{ params })
    return response.data
  },
  findById: async (id) => {
    const response = await axiosInstance.get('/smk-major/'+id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/smk-major', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/smk-major/${id}`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/smk-major/${id}`)
    return response.data
  },
}
